/**
 * Appends Supabase Storage image transformation query params to a URL.
 * Only applies to Supabase storage URLs; other URLs are returned unchanged.
 * @see https://supabase.com/docs/guides/storage/serving/image-transformations
 */
export function optimiseImageUrl(
  url: string,
  options: { width?: number; height?: number; quality?: number } = {}
): string {
  if (!url.includes('supabase.co/storage/v1/object/public/')) return url;

  // Use the render endpoint for transforms
  const transformed = url.replace(
    '/storage/v1/object/public/',
    '/storage/v1/render/image/public/'
  );

  const params = new URLSearchParams();
  if (options.width) params.set('width', String(options.width));
  if (options.height) params.set('height', String(options.height));
  params.set('quality', String(options.quality ?? 75));
  params.set('format', 'origin');

  return `${transformed}?${params.toString()}`;
}
